'use client';
var classes = {"root":"m-b32e4812","svg":"m-d43b5134","curve":"m-b1ca1fbf","label":"m-b23f9dc4"};

export { classes as default };
//# sourceMappingURL=RingProgress.module.css.mjs.map
